export type BgmTagOption = {
  code: number;
  translationKey: string;
};

// 에디터에 노출하는 태그 목록은 백엔드 enum과 동일한 계약을 유지해야 한다.
// 기준 소스: be-api/domain/src/main/java/com/crabs/domain/sharedAsset/code/SharedAssetTag.java
export const BGM_TAG_OPTIONS: BgmTagOption[] = [
  { code: 100, translationKey: 'Editor.audio-panel.bgm-tag.powerful' },
  { code: 101, translationKey: 'Editor.audio-panel.bgm-tag.happy' },
  { code: 102, translationKey: 'Editor.audio-panel.bgm-tag.funny' },
  { code: 103, translationKey: 'Editor.audio-panel.bgm-tag.hopeful' },
  { code: 104, translationKey: 'Editor.audio-panel.bgm-tag.peaceful' },
  { code: 105, translationKey: 'Editor.audio-panel.bgm-tag.mysterious' },
  { code: 106, translationKey: 'Editor.audio-panel.bgm-tag.dramatic' },
  { code: 107, translationKey: 'Editor.audio-panel.bgm-tag.tense' },
  { code: 108, translationKey: 'Editor.audio-panel.bgm-tag.dark' },
  { code: 109, translationKey: 'Editor.audio-panel.bgm-tag.cute' },
  { code: 110, translationKey: 'Editor.audio-panel.bgm-tag.emotional' },
  { code: 111, translationKey: 'Editor.audio-panel.bgm-tag.dreamy' },
  { code: 112, translationKey: 'Editor.audio-panel.bgm-tag.sad' },
];

export function toggleBgmTagSelection(
  selectedTags: number[],
  tagCode: number,
): number[] {
  const nextTags = selectedTags.includes(tagCode)
    ? selectedTags.filter((selectedTag) => selectedTag !== tagCode)
    : [...selectedTags, tagCode];

  // 같은 조합이면 항상 같은 순서가 되도록 정규화해서 query/cache 키를 안정화한다.
  return [...new Set(nextTags)].sort((left, right) => left - right);
}

export function getSelectedBgmTagsQuery(
  selectedTags: number[],
): number[] | undefined {
  if (selectedTags.length === 0) {
    return undefined;
  }

  // 태그를 하나도 고르지 않은 상태를 "전체"로 취급하므로, 실제 필터링일 때만 tags를 보낸다.
  return [...selectedTags].sort((left, right) => left - right);
}
